<template>
  <template v-for="attribute in attributes" :key="attribute.id">
    <div class="sm:col-span-3">
      <label class="label-form">
        {{ attribute.agro_exporter_container_attribute.name }} {{ attribute.data_type_id }}
      </label>
      <div class="mt-1">
        <!-- String data type -->
        <input
          v-if="[1, 3].includes(attribute.data_type_id)"
          :type="inputType(attribute.data_type_id)"
          v-model="localValuesMap[attribute.id].value"
          class="input-text"
        />

        <!-- Select data type using custom component -->
        <select-form
          v-else-if="attribute.data_type_id === 2"
          :options="attribute.options"
          label="value"
          v-model="localValuesMap[attribute.id].exporter_process_container_attribute_option_id"
        />
      </div>
    </div>
  </template>
</template>

<script>
export default {
  name: "ContainerAttributesInput",
  props: {
    attributes: {
      type: Array,
      required: true
    },
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      local_values: []
    };
  },
  computed: {
    localValuesMap() {
      return this.local_values.reduce((map, entry) => {
        map[entry.exporter_process_container_attribute_id] = entry;
        return map;
      }, {});
    }
  },
  watch: {
    attributes: {
      handler(attrs) {
        // Crear un mapa de los valores existentes para facilitar su acceso
        const existingValues = this.modelValue.reduce((map, item) => {
          map[item.exporter_process_container_attribute_id] = item;
          return map;
        }, {});

        this.local_values = attrs.map(attr => {
          // Buscar el valor existente para este atributo
          const existingValue = existingValues[attr.id];

          if (existingValue) {
            // Si ya existe, mantenemos su estructura y valores
            return {
              ...existingValue,
              exporter_process_container_attribute_id: attr.id
            };
          } else {
            // Si no existe, creamos uno nuevo
            return {
              exporter_process_container_attribute_id: attr.id,
              exporter_process_container_attribute_option_id: null,
              value: ''
            };
          }
        });

        this.$emit('update:modelValue', this.local_values);
      },
      immediate: true
    },
    modelValue: {
      handler(newVal) {
        // Actualizar los valores locales cuando cambie el modelValue externamente
        if (newVal.length && this.local_values.length === 0) {
          this.local_values = [...newVal];
        }
      },
      immediate: true
    },
    local_values: {
      handler(vals) {
        this.$emit('update:modelValue', vals);
      },
      deep: true
    }
  },
  methods: {
    inputType(dataTypeId) {
      switch (dataTypeId) {
        case 1:
          return 'text';
        case 2:
          return 'select';
        case 3:
          return 'number';
        default:
          return 'text';
      }
    }
  }
};
</script>
